export default __webpack_public_path__ + "static/media/rs.c003c111.svg";